module.exports = __webpack_public_path__ + "img/mehoonri.ebe92c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/mehoonri.jpg
// module id = 1086
// module chunks = 1